export default __webpack_public_path__ + "media/images/features/local_delivery/people-53a729c7ef84d7e1003bdfdee859c6aa.png";